import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { CreditService } from '../credit.service';
import { BaseManagement } from 'src/app/core/services/base-management';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { CardFormatterService } from 'src/app/core/services/card-formatter.service';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';

declare var $: any;
declare var Payment: any;

var PaymentMethod = {
  id: "",
  cardType: "",
  cardName: "",
  number: "",
  expiry: "",
  cvc: "",
  name: "",
  isDefault: ""
}

@Component({
  selector: 'prgov-credit-purchase-modal',
  templateUrl: './credit-purchase-modal.component.html',
  styleUrls: ['./credit-purchase-modal.component.scss']
})
export class CreditPurchaseModalComponent extends BaseManagement implements OnInit {	

  form : FormGroup;
  paymentType: any = "NA";
  feeAmount: any = 0;
  invoiceNumber: any = 0;
  cardTypeChangeEvent: any;
  getBalanceEvent: any;
  subscriptions: Subscription[] = [];
  toggleAddCredit: boolean = false;

  constructor(

    public translate: TranslateService,
    public mainService: CreditService,
    private formBuilder: FormBuilder,
    public cardFormatterService: CardFormatterService,
    public dialog: MatDialog,    
  	public router: Router,
    public dialogRef: MatDialogRef<CreditPurchaseModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super();
    this.form = this.formBuilder.group(
      {
        Quantity: ['', 
        Validators.compose([Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)])
        ],
        CardNumber: ['',
        Validators.compose([Validators.required, Validators.minLength(17)])
        ],
        Expiry: [
          '',Validators.compose([Validators.required, Validators.minLength(9)])
        ],
        CVC: ['', 
        Validators.compose([Validators.required])
        ],
        CardType: ['', 
        Validators.compose([Validators.required])
        ],
        NameOnCard: ['', Validators.compose([Validators.required])
        ],
        PaymentAddress: ['', Validators.compose([Validators.required])],
      },
      {
        validator: this.paymentInfoValidation,
      }
    );
  }  
  
  ngOnInit() {
    this.refreshLanguage();
    this.mainService.getBalance();
    this.cardTypeChangeEvent = this.cardFormatterService.cardTypeChangeEvent.subscribe((paymentType)=>{
      this.paymentType = paymentType;

      this.form.patchValue({
        CardType: paymentType,
      });      
    });
    this.getBalanceEvent = this.mainService.getBalanceEvent
    .subscribe((data: any)=>{
        this.mainService.getBalance()
        .then((data: any)=>{
          this.close();          
        });
        
    });
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(s => s.unsubscribe());
  }
    
  formatValue(e){
    this.cardFormatterService.monitorCcFormat($(e.currentTarget));
  }
  
  paymentInfoValidation(control: AbstractControl) {
    let cardNumber = control.get('CardNumber').value; 
    let expiry = control.get('Expiry').value; 

    var pad = (num, size) => {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        
        return num;
    };

    if(expiry.indexOf("/")>=0 && expiry.length == 9){
      let expiryArray = expiry.split('/');
      let date = new Date();

      let expiryMonth = parseInt(expiryArray[0]);
      let expiryYear = parseInt(expiryArray[1]);
      let currentMonth = date.getMonth() + 1;
      let currentYear = date.getFullYear();

      try{        

      let specifiedDate = new Date(expiryYear,expiryMonth);
      let currentDate = new Date();

      expiryMonth = pad(expiryMonth, 2);
      currentMonth = pad(currentMonth, 2);
      currentYear= pad(currentYear, 4);

      if(expiryMonth > 12 || expiryMonth <= 0 ){
          this.mainService.toggleDateFormatError = true;
      }

      console.log('specifiedDate', specifiedDate);
      console.log('currentDate', currentDate)      
  
      if(specifiedDate<currentDate || !specifiedDate){
        control.get('Expiry').setErrors( {invalidDate: true} )
      }
      }catch(e){
        control.get('Expiry').setErrors( {invalidDate: true} )
      }
    }else{
      control.get('Expiry').setErrors( {invalidDate: true} )
    } 

    return null  

  } 

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;  
  }

  tryPay() {
    this.translate
    .get(['payment.tryPaySubmit', 'message.yes', 'message.no'])
    .subscribe((translations) => {
      if (this.isSaving()) {
        return false;
      }

      const dialogRef = this.dialog.open(DialogYesNoComponent, {
        width: '250px',
        data: {
          msg: translations['payment.tryPaySubmit'],
          yesText: translations['message.yes'],
          noText: translations['message.no'],
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == 1) {              
            this.pay();
        }
      });          
    });
  }

  pay() {
    this.translate
    .get(['payment.invoiceSuccess', 'payment.serverError'])
    .subscribe((translations) => {
      if (this.isSaving()) {
        return false;
      }

      this.startSaving('payAndSubmit');

      this.serverError = '';

      var paymentData = this.setupPaymentData();

      this.mainService
        .pay(paymentData)
        .then((result: any) => {
          this.stopSaving();

          if (result.Success === true) {
            const dialogRef = this.dialog.open(DialogYesNoComponent, {
              width: '250px',
              data: {
                msg: translations['payment.invoiceSuccess'],
                yesText: 'Ok',
              },
            });

            dialogRef.afterClosed().subscribe((result) => {  
              this.toggleAddCredit = false;              
              this.getBalanceEvent.next(); 
                             
            });
          } else {
            this.serverError = result.Message
              ? result.Message
              : translations['payment.serverError'];
          }
      })
      .catch((error: any) => {
        this.stopSaving();
        console.error('Error en el pago:', error);
        this.serverError = error && error.Message 
          ? error.Message 
          : translations['payment.serverError'];
      });
    });
  }

  setupPaymentData() {
      let expiry = this.form.controls.Expiry.value;
      let expiryMonth = 0;
      let expiryYear = 0;
  
      if (expiry.indexOf('/') >= 0 && expiry.length == 9) {
        let expiryArray = expiry.split('/');
        let date = new Date();
  
        expiryMonth = parseInt(expiryArray[0]);
        expiryYear = parseInt(expiryArray[1]);
      }
  
      // Usar PaymentAddress.value directamente como en payment-form
      const additionalInfo = this.form.controls.PaymentAddress.value;

      // Agregar NameOnCard y LastFourDigits
      additionalInfo.NameOnCard = this.form.controls.NameOnCard.value;

      let card = this.form.controls.CardNumber.value.substr(
        this.form.controls.CardNumber.value.length - 4
      );

      additionalInfo.LastFourDigits = card;

      // Obtener zip del PaymentAddress
      let zip = this.form.controls.PaymentAddress.value && this.form.controls.PaymentAddress.value.PostalCode 
        ? this.form.controls.PaymentAddress.value.PostalCode 
        : null;
  
      let data = {
        "CardType": this.form.controls.CardType.value,
        "accountNumber": this.form.controls.CardNumber.value,
  
        "amountOfTransaction": this.form.controls.Quantity.value,
        
        "CVV2_CVC2": this.form.controls.CVC.value,
  
        "expirationMonth": expiryMonth,
        "expirationYear": expiryYear,
        "name": this.form.controls.NameOnCard.value,
        "feeAmount": this.feeAmount,
  
        "additionalInfo": JSON.stringify(additionalInfo),
        "zip": zip || (additionalInfo && additionalInfo.PostalCode ? additionalInfo.PostalCode : null)
      };
  
      return data;
  }

  close(){
		this.dialogRef.close();
	}

}
